<template>
  <div class="development-page">
    <div class="content">
      <div class="icon">
        <a-icon type="info-circle" style="font-size: 64px; color: #fc6732;" />
      </div>
      <div class="text">
        <h2 class="title">待开发中</h2>
        <p class="subtitle">该功能正在开发中，敬请期待</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Development'
}
</script>

<style scoped>
.development-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text {
  text-align: center;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: #1B1C33;
  margin: 0 0 8px 0;
}

.subtitle {
  font-size: 14px;
  color: #5E5E66;
  margin: 0;
}
</style>
